
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" border>
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="bizCode" width="140px" label="单据编号" />
        <el-table-column show-overflow-tooltip prop="materialName" min-width="120px" label="物料名称" />
        <el-table-column show-overflow-tooltip prop="specification" width="120px" label="规格型号">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="packLevel" width="120px" label="包装层级">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialCode" width="120px" label="物料编码">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="code" min-width="180px" label="UDI码">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createBy" width="120" label="操作人" />
        <el-table-column show-overflow-tooltip width="120" label="拆箱时间">
          <template slot-scope="scope">
            {{ scope.row.createTime ? parseTime(scope.row.createTime) : null }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="130" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="$btnsPermission('upPackingRecords:ck')" type="text" @click="handlePreview(row)">查看内层UDI</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <detailRecords v-if="previewShow" :visible="previewShow" :un-packing-info="unPackingInfo" @close="close">
    </detailRecords>
  </div>
</template>

<script>
import { getUppackingRecordsList } from '@/api/upPackingRecords'
import detailRecords from './components/detailRecords'
export default {
  components: {
    detailRecords,
  },
  data() {
    return {

      heightStyleObj: '',
      loading: true, // 遮罩
      previewShow: false, // 查看
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '物料名称/规格型号/物料编码/UDI码',
          width: '300px',
          type: 'input'
        },
        {
          label: '包装层级',
          field: 'packLevel',
          type: 'input',
        },
      ],
      unPackingInfo: {},
      searchParam: { // 查询参数
        packLevel: null,
        searchValue: null,
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },


  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()

  },
  methods: {
    handlePreview(row) {
      this.unPackingInfo = row
      this.previewShow = true
    },
    // 关闭弹窗
    close() {
      this.previewShow = false;
      this.unPackingInfo = {}
      this.getPageListData()
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startTime, endTime] = searchParam.dateTime
        searchParam.startTime = startTime
        searchParam.endTime = endTime
        delete searchParam.dateTime
      }
      getUppackingRecordsList(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
